module.exports = __webpack_public_path__ + "img/sns-icon-mail.57c25582.png";